// /Users/vijayakumarreddygajjala/zninth/Ascentra-2.0/my-ascentra-app/src/Common/utils/utils.js

export const generateGuid = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  });
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC"
  });
  return `${formattedDate} ${formattedTime}`;
};


// Returns duration as mm:ss (e.g. "00:07", "01:23")
export const getTimeDiffInSeconds = (endTime, startTime) => {
  if (!endTime || !startTime) return "N/A";
  const end = new Date(endTime);
  const start = new Date(startTime);
  if (isNaN(end.getTime()) || isNaN(start.getTime())) return "--:--";
  const totalSeconds = Math.max(0, Math.round((end.getTime() - start.getTime()) / 1000));
  const mm = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const ss = String(totalSeconds % 60).padStart(2, "0");
  return `${mm}:${ss}`;
};

// Returns elapsed offset from a run's startedAt for a single log entry as +mm:ss
export const formatElapsed = (loggedAt, startedAt) => {
  if (!loggedAt || !startedAt) return "";
  const end = new Date(loggedAt);
  const start = new Date(startedAt);
  if (isNaN(end.getTime()) || isNaN(start.getTime())) return "";
  const totalSeconds = Math.max(0, Math.round((end.getTime() - start.getTime()) / 1000));
  const mm = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const ss = String(totalSeconds % 60).padStart(2, "0");
  return `+${mm}:${ss}`;
};

export const extractPlaceholders = (url) => {
  const placeholders = [];
  const regex = /\{([^}]+)\}/g; // Regular expression to match {word}

  let match;
  while ((match = regex.exec(url)) !== null) {
    placeholders.push(match[1]); // Push the captured word (group 1)
  }

  return placeholders;
}

export const getDynamicSchema = (placeholders) => {
  const properties = {};
  const required = [];

  placeholders.forEach((placeholder, index) => {
    const propertyName = placeholder; // Use the placeholder name directly
    properties[propertyName] = {
      type: "string",
    };
    required.push(propertyName); // Add all placeholders to the required array
  });

  const schema = {
    type: "object",
    properties: properties,
    required: required,
  };

  return JSON.stringify(schema, null, 2);
};

export const parseError = (error) => {
  if (error?.response?.data) {
    const data = error.response.data;

    // If the server sent a plain string, try to parse it as JSON first
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        if (parsed?.detail) return parsed.detail;
        if (parsed?.message) return parsed.message;
        if (parsed?.error) return parsed.error;
      } catch {
        // Not JSON — return the string only if it looks like a human message
        if (data.length < 300 && !data.startsWith('{') && !data.startsWith('[')) return data;
      }
    }

    if (typeof data === 'object') {
      // Standard Django / DRF error fields
      if (data.non_field_errors) {
        const msg = Array.isArray(data.non_field_errors) ? data.non_field_errors[0] : data.non_field_errors;
        return typeof msg === 'string' ? msg : "An error occurred.";
      }
      if (typeof data.detail === 'string') return data.detail;
      if (typeof data.error === 'string') return data.error;
      if (typeof data.message === 'string') return data.message;

      // Field-level validation errors — pick the first readable one
      for (const [field, errors] of Object.entries(data)) {
        const errorMsg = Array.isArray(errors) ? errors[0] : errors;
        if (typeof errorMsg === 'string') {
          const fieldName = field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ');
          return `${fieldName}: ${errorMsg}`;
        }
      }
    }
  }

  // Friendly fallbacks for common HTTP status codes
  const status = error?.response?.status;
  if (status === 400) return "Invalid request. Please check your input.";
  if (status === 401) return "Session expired. Please log in again.";
  if (status === 403) return "You do not have permission to perform this action.";
  if (status === 404) return "The requested resource was not found.";
  if (status === 500) return "A server error occurred. Please try again.";
  if (status === 502 || status === 503) return "Service is temporarily unavailable. Please try again.";

  // Network errors (no response at all)
  if (!error?.response) return "Unable to connect. Please check your internet connection.";

  return "An unexpected error occurred.";
};

